import React, { createContext, useContext, useState, useCallback } from "react";

const dictionaries = {
  pt: {
    nav_artists: "Artistas",
    nav_portfolio: "Portfólio",
    nav_manifesto: "Manifesto",
    nav_space: "Espaço",
    nav_booking: "Agendar",
    nav_location: "Localização",
    hero_cta_book: "Agendar sessão",
    hero_cta_portfolio: "Ver portfólio",
    hero_scroll: "Role para baixo",
    artists_title: "Artistas",
    artists_subtitle: "Cinco mãos, cinco assinaturas. Escolha a sua.",
    artists_view_gallery: "Ver galeria",
    artists_works: "Trabalhos",
    artist_book: "Marcar com o studio",
    portfolio_title: "Portfólio",
    portfolio_subtitle: "Tinta na pele. Registro do que sai das nossas máquinas.",
    portfolio_filter_all: "Todos",
    manifesto_title: "Manifesto",
    space_title: "O Espaço",
    space_subtitle: "Diferente de qualquer estúdio que você já viu.",
    booking_title: "Agendamento",
    location_title: "Localização",
    hours_title: "Horários",
    contact_title: "Contato",
    footer_rights: "Todos os direitos reservados.",
    footer_admin: "Área admin",
    loading: "Carregando",
    close: "Fechar",
  },
  en: {
    nav_artists: "Artists",
    nav_portfolio: "Portfolio",
    nav_manifesto: "Manifesto",
    nav_space: "Space",
    nav_booking: "Book",
    nav_location: "Location",
    hero_cta_book: "Book a session",
    hero_cta_portfolio: "View portfolio",
    hero_scroll: "Scroll down",
    artists_title: "Artists",
    artists_subtitle: "Five hands, five signatures. Pick yours.",
    artists_view_gallery: "View gallery",
    artists_works: "Works",
    artist_book: "Book with the studio",
    portfolio_title: "Portfolio",
    portfolio_subtitle: "Ink on skin. A record of what leaves our machines.",
    portfolio_filter_all: "All",
    manifesto_title: "Manifesto",
    space_title: "The Space",
    space_subtitle: "Unlike any studio you've ever seen.",
    booking_title: "Booking",
    location_title: "Location",
    hours_title: "Hours",
    contact_title: "Contact",
    footer_rights: "All rights reserved.",
    footer_admin: "Admin area",
    loading: "Loading",
    close: "Close",
  },
  de: {
    nav_artists: "Künstler",
    nav_portfolio: "Portfolio",
    nav_manifesto: "Manifest",
    nav_space: "Studio",
    nav_booking: "Termin",
    nav_location: "Standort",
    hero_cta_book: "Session buchen",
    hero_cta_portfolio: "Portfolio ansehen",
    hero_scroll: "Nach unten scrollen",
    artists_title: "Künstler",
    artists_subtitle: "Fünf Hände, fünf Handschriften. Wähle deine.",
    artists_view_gallery: "Galerie ansehen",
    artists_works: "Arbeiten",
    artist_book: "Beim Studio buchen",
    portfolio_title: "Portfolio",
    portfolio_subtitle: "Tinte auf Haut. Ein Archiv dessen, was unsere Maschinen verlassen.",
    portfolio_filter_all: "Alle",
    manifesto_title: "Manifest",
    space_title: "Das Studio",
    space_subtitle: "Anders als jedes Studio, das du je gesehen hast.",
    booking_title: "Terminbuchung",
    location_title: "Standort",
    hours_title: "Öffnungszeiten",
    contact_title: "Kontakt",
    footer_rights: "Alle Rechte vorbehalten.",
    footer_admin: "Admin-Bereich",
    loading: "Laden",
    close: "Schließen",
  },
};

const LangContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "pt");
  const change = useCallback((l) => {
    localStorage.setItem("lang", l);
    setLang(l);
  }, []);
  const t = useCallback((key) => dictionaries[lang]?.[key] ?? dictionaries.pt[key] ?? key, [lang]);
  const pick = useCallback((field) => {
    if (!field) return "";
    if (typeof field === "string") return field;
    return field[lang] || field.pt || field.en || field.de || "";
  }, [lang]);
  return (
    <LangContext.Provider value={{ lang, setLang: change, t, pick }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLanguage = () => useContext(LangContext);
